import { render, staticRenderFns } from "./StudentBottomPanel.vue?vue&type=template&id=93f588bc&scoped=true&lang=pug&"
import script from "./StudentBottomPanel.vue?vue&type=script&lang=ts&"
export * from "./StudentBottomPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StudentBottomPanel.vue?vue&type=style&index=0&id=93f588bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f588bc",
  null
  
)

export default component.exports